// Atoms pertaining to the currently active frame
import { atom, getDefaultStore } from 'jotai/vanilla';
import { IFrame, IGraphQLResponse, ISection } from '../interfaces';
import application from './application';
import api from './api';
import { get_query } from './helpers';
import component from './component';
import { selectAtom } from 'jotai/vanilla/utils';

interface IUpdateFrame {
  active_section?: IFrame;
  complete?: boolean;
}

const primitive_data = atom<Omit<IFrame, 'application_id'>>({
  button: '',
  section: '',
  sections: [],
  frames: [],
});

const data = atom(
  (get) => ({
    ...get(primitive_data),
    application_id: get(application.application_id),
  }),
  (_get, set, newFrame: IFrame) => {
    const { application_id, ...rest } = newFrame;

    set(application.application_id, application_id);
    set(primitive_data, rest);
  },
);

const update = atom(null, (get, set, { active_section, complete }: IUpdateFrame) => {
  if (active_section) {
    const components = active_section.frames?.flatMap((f) => f.components) ?? [];
    if (components.length > 0) {
      set(
        component.list,
        components.map((c) => set(component.parser, c)),
      );
    }
    set(data, active_section);
  }
  set(application.is_complete, complete ?? false);
});

data.onMount = () => {
  const { get, set } = getDefaultStore();
  get(api.client)
    .rawRequest<IGraphQLResponse>(get_query())
    .then(({ data }) => {
      if (!data || !data.application) return;
      const active_section = data.application.firstSection ?? data.activeSection;
      if (active_section) {
        set(update, {
          active_section: {
            application_id: '',
            button: active_section.button,
            section: active_section.id,
            sections: data.application.sections,
            frames: active_section.frames,
          },
        });
      }
    });
};
export const sections = selectAtom<IFrame, ISection[]>(data, (data) => data.sections);
export const section = atom((get) => {
  const section_id = get(selectSession);
  const query_params = get(application.query_params);
  const section = get(sections).find((s) => s.id === section_id);
  if (!query_params.has('section') || query_params.get('section') !== section?.name) {
    query_params.set('section', section?.name ?? '');
    window.history.replaceState(null, '', `?${query_params.toString()}`);
  }
  return section_id;
});

export const selectSession = selectAtom<IFrame, string>(data, (data) => data.section);

export default {
  data,
  update,
  sections,
  section,
};
